module.exports = __webpack_public_path__ + "static/media/canQuestion.f203b0fa.png";